import { UseMutationDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition';
import type { IImportTableDefinitionRepository } from '@front/repository/Api/ImportTableDefinition/interface';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { importTableDefinitionQueryKeys } from './queryKeys';

const repository = new ImportTableDefinitionRepository();

export const _activateRevision = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params: IImportTableDefinitionRepository.ActivateRevision.Params) => {
      return repository.activateRevision(params, { signal: signalToTimeout(DEFAULT_TIMEOUT.MUTATION) });
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: importTableDefinitionQueryKeys.detail(variables.projectId, variables.id),
        refetchType: 'all',
      });
      void queryClient.invalidateQueries({
        queryKey: importTableDefinitionQueryKeys.listPrefix(variables.projectId),
        refetchType: 'all',
      });
    },
    ...UseMutationDefaultOptions,
  });
};
